import apiClient from '../api/apiClient';
import supplierService from './supplierService';

class RealInventoryService {
  async getSuppliers(params = {}) {
    const { suppliers, pagination } = await supplierService.listSuppliers(params);
    return {
      success: true,
      data: { suppliers, pagination },
    };
  }

  async getLots(productId, params = {}) {
    const response = await apiClient.get(`/api/v1/admin/real-inventory/${productId}/lots`, {
      params,
    });
    return response.data;
  }

  async addLot(productId, payload) {
    const response = await apiClient.post(`/api/v1/admin/real-inventory/${productId}/lots`, payload);
    return response.data;
  }

  async getLotTransactions(lotUuid) {
    const response = await apiClient.get(`/api/v1/admin/real-inventory/lots/${lotUuid}/transactions`);
    return response.data;
  }
}

const realInventoryService = new RealInventoryService();
export default realInventoryService;
